module.exports = __webpack_public_path__ + "img/p_sz_7.84c82fb5.svg";